import React from 'react';

// Tarjeta del análisis de IA (statusBot.prediction): tendencia y confianza.
const IaTrend = ({ prediction }) => {
  if (!prediction || prediction.error) return null;
  const isAlza = prediction.prediction === 1;
  const confidence = Math.max(prediction.probability_up, prediction.probability_down) * 100;
  return (
    <div style={{
      background: isAlza ? 'rgba(45,206,137,0.08)' : 'rgba(245,54,92,0.08)',
      border: `2px solid ${isAlza ? '#2dce89' : '#f5365c'}`,
      borderRadius: 12,
      padding: '14px 16px',
    }}>
      <div style={{ fontSize: 11, color: '#8898aa', fontWeight: 700, textTransform: 'uppercase', marginBottom: 6 }}>IA Tendencia</div>
      <div style={{ fontSize: 22, fontWeight: 800, color: isAlza ? '#2dce89' : '#f5365c', marginBottom: 8 }}>
        {isAlza ? 'ALZA 🚀' : 'BAJA 📉'}
      </div>
      <div style={{ fontSize: 11, color: '#8898aa', marginBottom: 3 }}>
        Confianza: <strong style={{ color: '#32325d' }}>{confidence.toFixed(1)}%</strong>
      </div>
      <div style={{ display: 'flex', height: 6, borderRadius: 3, overflow: 'hidden', gap: 1 }}>
        <div style={{ width: `${prediction.probability_up * 100}%`, background: '#2dce89' }} />
        <div style={{ width: `${prediction.probability_down * 100}%`, background: '#f5365c' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 3, fontSize: 10, color: '#8898aa' }}>
        <span>↑ {(prediction.probability_up * 100).toFixed(1)}%</span>
        <span>{(prediction.probability_down * 100).toFixed(1)}% ↓</span>
      </div>
    </div>
  );
};

export default IaTrend;
